const tagToSymbols = {
  b: '**',
  strong: '**',
  i: '*',
  em: '*',
  u: '__',
  s: '~~',
  strike: '~~',
};

const tagToNewLine = {
  br: { ignoreInNewLine: false },
  div: { ignoreInNewLine: true },
};

const formattingTags = ['b', 'strong', 'i', 'em', 'u', 's', 'strike'];

const getReplacingChar = (text, tag) => {
  if (tagToNewLine[tag].ignoreInNewLine) {
    const match = text.match(new RegExp(`<${tag}(.*?)>`));
    if (match && (match.index === 0 || text[match.index - 1] === '\n')) {
      return '';
    }
  }

  return '\n';
};

/**
 * Удаляет пробелы и переносы строк между закрывающими тегами форматирования.
 * Исправляет проблему, когда contenteditable браузера создаёт HTML вида "</b>\n</i>",
 * что приводит к сломанному markdown "**\n*" вместо корректного "***"
 */
const normalizeClosingTags = (html) => {
  if (!html) {
    return '';
  }

  let result = html;
  let changed = true;
  while (changed) {
    changed = false;
    for (const tag of formattingTags) {
      for (const nextTag of formattingTags) {
        const pattern = new RegExp(`</${tag}>\\s+</${nextTag}>`, 'g');
        const replacement = `</${tag}></${nextTag}>`;
        const newResult = result.replace(pattern, replacement);
        if (newResult !== result) {
          result = newResult;
          changed = true;
        }
      }
    }
  }

  return result;
};

export const replaceHtmlTagsToSpecialSymbols = (value) => {
  let text = normalizeClosingTags(value);

  const div = document.createElement('div');
  div.innerHTML = text;

  const nodes = div.getElementsByTagName('*');

  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];

    const lowercaseTag = node.tagName.toLowerCase();

    if (lowercaseTag === 'a') {
      text = text.replace(new RegExp(`<a(.*?)>`), '[');
      text = text.replace(new RegExp(`</a>`), `](${node.getAttribute('href')})`);
      continue;
    }

    if (tagToNewLine[lowercaseTag]) {
      const replaceTo = getReplacingChar(text, lowercaseTag);

      text = text.replace(new RegExp(`<${lowercaseTag}(.*?)>`), replaceTo);
      text = text.replace(new RegExp(`</${lowercaseTag}>`), '');
      continue;
    }

    const symbols = tagToSymbols[lowercaseTag] || '';

    text = text.replace(new RegExp(`<${lowercaseTag}(.*?)>`, 'g'), symbols);
    text = text.replace(new RegExp(`</${lowercaseTag}>`, 'g'), symbols);
  }

  div.innerHTML = text;

  return div.innerText;
};
